module.exports = __webpack_public_path__ + "img/my-coin-shadow.88ce8959.png";